module.exports = __webpack_public_path__ + "img/arrow-down-right-circle.74445e2b.svg";